import { useEffect, useState } from "react";
import CustomCommandBar from "../../Components/CustomCommandBar/CustomCommandBar";
import NavigationMenu from "../../Components/NavigationMenu/NavigationMenu";
import "./DomoticaPage.scss";
import { IGenericLog } from "../../Models/IGenericLog";
import Loadable from "../../Components/Loadable/Loadable";
import DataTable from "../../Components/DataTable/DataTable";
import ApiService from "../../Services/ApiService";
import { response } from "express";
import { IAPIResponse } from "../../Services/AjaxService";
import { Label, PrimaryButton } from "@fluentui/react";
// import { getMqttUrl, getMqttCredentials } from "../../Config";

/**
 * ⚠️ ARCHITETTURA RIDONDANTE - MQTT NON DOVREBBE ESSERE NEL FRONTEND
 * 
 * Il codice MQTT in questo file è stato commentato per i seguenti motivi:
 * 
 * 1. SICUREZZA: Le credenziali MQTT (username/password) sono esposte nel browser
 *    - Chiunque può ispezionare il codice e vedere le credenziali
 *    - Le credenziali sono visibili nel network tab degli strumenti di sviluppo
 * 
 * 2. SCALABILITÀ: Ogni client frontend apre una connessione WebSocket al broker MQTT
 *    - Con N utenti connessi = N connessioni WebSocket al broker
 *    - Questo sovraccarica il broker MQTT inutilmente
 * 
 * 3. ARCHITETTURA: Il backend dovrebbe gestire tutta la logica MQTT
 *    - Separazione delle responsabilità: Frontend = UI, Backend = Business Logic
 *    - Il backend ha già un subscriber MQTT che riceve i messaggi dai sensori
 * 
 * 4. MANUTENIBILITÀ: Logica di business centralizzata nel backend
 *    - Più facile da debuggare e monitorare
 *    - Un solo punto di gestione per MQTT
 * 
 * ARCHITETTURA CORRETTA:
 * ┌─────────┐     ┌──────────────┐     ┌─────────────────────┐     ┌──────────┐     ┌──────────┐
 * │ Sensori │ --> │ MQTT Broker  │ --> │ Backend (Subscriber)│ --> │ Database │ --> │ API REST │
 * └─────────┘     └──────────────┘     └─────────────────────┘     └──────────┘     └──────────┘
 *                                                                                            │
 *                                                                                            ▼
 *                                                                                     ┌──────────┐
 *                                                                                     │ Frontend │
 *                                                                                     └──────────┘
 * 
 * Il frontend dovrebbe:
 * - Chiamare API REST per inviare comandi all'attuatore (es: POST /api/actuator/on)
 * - Fare polling delle API per ricevere lo stato (es: GET /api/actuator/status)
 * - NON connettersi direttamente al broker MQTT
 * 
 * Il backend dovrebbe:
 * - Ricevere comandi dal frontend via API REST
 * - Pubblicare comandi MQTT al broker
 * - Ricevere risposte dai dispositivi via MQTT
 * - Salvare lo stato nel database
 * - Esporre lo stato via API REST
 */

// Dichiarazione delle variabili per la connessione MQTT
// ⚠️ COMMENTATO - Non serve connessione MQTT diretta dal frontend
// let client: any = null;
// let isConnected = false;

// Funzioni per i comandi dell'attuatore
// ⚠️ COMMENTATO - Questi comandi dovrebbero essere API REST, non MQTT diretti
// const ActuatorCommands = {
//   On: () => {
//     if (client && isConnected) {
//       client.publish("shelly1minig3-ecda3bc2347c/command/switch:0", "on");
//     }
//   },
//   RequestStatus: () => {
//     if (client && isConnected) {
//       client.publish(
//         "shelly1minig3-ecda3bc2347c/command/switch:0",
//         "status_update"
//       );
//     }
//   },
//   Off: () => {
//     if (client && isConnected) {
//       client.publish("shelly1minig3-ecda3bc2347c/command/switch:0", "off");
//     }
//   },
// };

/**
 * IMPLEMENTAZIONE CORRETTA - Usare API REST invece di MQTT
 * 
 * const ActuatorCommands = {
 *   On: async () => {
 *     try {
 *       const response = await fetch('/api/actuator/on', { method: 'POST' });
 *       if (response.ok) {
 *         console.log('Attuatore acceso');
 *       }
 *     } catch (error) {
 *       console.error('Errore accensione attuatore:', error);
 *     }
 *   },
 *   RequestStatus: async () => {
 *     try {
 *       const response = await fetch('/api/actuator/status');
 *       const data = await response.json();
 *       return data.status;
 *     } catch (error) {
 *       console.error('Errore richiesta stato:', error);
 *     }
 *   },
 *   Off: async () => {
 *     try {
 *       const response = await fetch('/api/actuator/off', { method: 'POST' });
 *       if (response.ok) {
 *         console.log('Attuatore spento');
 *       }
 *     } catch (error) {
 *       console.error('Errore spegnimento attuatore:', error);
 *     }
 *   },
 * };
 */

// Funzione per inizializzare la connessione MQTT
// ⚠️ COMMENTATO - Il frontend non dovrebbe connettersi direttamente a MQTT
// const initializeMqttConnection = () => {
//   if (!client && (window as any).mqtt) {
//     try {
//       console.log("🔧 Inizializzazione connessione MQTT per DomoticaPage");
//       client = (window as any).mqtt.connect(getMqttUrl(), getMqttCredentials());
//
//       client.on("connect", function () {
//         console.log("✅ Connesso al broker MQTT");
//         isConnected = true;
//         // Subscribe to the status topic
//         client.subscribe(
//           "shelly1minig3-ecda3bc2347c/status/switch:0",
//           function (err: any) {
//             if (!err) {
//               console.log("✅ Iscritto al topic di stato");
//             } else {
//               console.error("❌ Errore di sottoscrizione al topic di stato:", err);
//             }
//           }
//         );
//       });
//
//       client.on("message", function (topic: any, message: any) {
//         console.log("📨 Shelly message", topic, message);
//         if (topic === "shelly1minig3-ecda3bc2347c/status/switch:0") {
//           let status = message.toString();
//           console.log("📊 Stato attuale:", status);
//           try {
//             let obj = JSON.parse(status);
//             document.dispatchEvent(
//               new CustomEvent("change-actuator-state", {
//                 detail: { status: obj.output ? "Acceso" : "Spento" },
//               })
//             );
//           } catch (e) {
//             console.error("❌ Errore parsing messaggio MQTT:", e);
//           }
//         }
//       });
//
//       client.on("error", function (err: any) {
//         console.error("❌ Errore di connessione MQTT:", err);
//         isConnected = false;
//       });
//
//       client.on("disconnect", function () {
//         console.log("🔌 Disconnesso dal broker MQTT");
//         isConnected = false;
//       });
//
//     } catch (error) {
//       console.error("❌ Errore inizializzazione MQTT:", error);
//     }
//   }
// };

// Funzione per chiudere la connessione MQTT
// ⚠️ COMMENTATO - Non serve se non c'è connessione MQTT
// const closeMqttConnection = () => {
//   if (client) {
//     console.log("🔌 Chiusura connessione MQTT");
//     client.end();
//     client = null;
//     isConnected = false;
//   }
// };

const DomoticaPage = () => {
  const [logs, setLogs] = useState<IGenericLog[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [actuatorState, setActuatorState] = useState<string>("Non rilevato");
  const [timer, setTimer] = useState<NodeJS.Timer | null>(null);

  const loadLogs = () => {
    setLoading(true);
    ApiService.GenericLogController.Get(
      "actuator-on-off",
      (response: IAPIResponse) => {
        if (response.error === null) {
          setLogs(response.parsed);
        }
        setLoading(false);
      }
    );
  };

  const updateState = (e: any) => {
    setActuatorState(e.detail.status);
  };

  useEffect(() => {
    loadLogs();
    
    // ⚠️ COMMENTATO - Inizializzazione MQTT non necessaria
    // Inizializza la connessione MQTT solo per questa pagina
    // initializeMqttConnection();
    
    // ⚠️ COMMENTATO - Polling MQTT non necessario
    // Invece, dovrebbe essere implementato un polling API REST:
    // const intervalTimer = setInterval(async () => {
    //   const status = await ActuatorCommands.RequestStatus();
    //   setActuatorState(status);
    // }, 1000);
    
    // Imposta il timer per richiedere lo stato periodicamente
    // const intervalTimer = setInterval(() => {
    //   ActuatorCommands.RequestStatus();
    // }, 1000);
    
    // setTimer(intervalTimer);
    
    document.addEventListener("change-actuator-state", updateState);
    
    return () => {
      document.removeEventListener("change-actuator-state", updateState);
      // if (intervalTimer) {
      //   clearInterval(intervalTimer);
      // }
      // ⚠️ COMMENTATO - Chiusura connessione MQTT non necessaria
      // Chiude la connessione MQTT quando il componente viene smontato
      // closeMqttConnection();
    };
  }, []);

  return (
    <div className="fade-in-whole-page">
      <CustomCommandBar
        specials={[
          <div className="command-bar-title">Domotica</div>,
          <NavigationMenu />,
        ]}
        buttons={[]}
      />

      <div className="sliding-page-content">
        <h2>Controlli attuatore</h2>
        <div style={{ display: "flex", gap: "1em", alignItems: "center" }}>
          <PrimaryButton
            disabled={actuatorState === "Acceso"}
            text="Attiva attuatore"
            onClick={() => {
              // ⚠️ COMMENTATO - Comando MQTT diretto
              // ActuatorCommands.On();
              
              // TODO: Implementare chiamata API REST
              // Example:
              // fetch('/api/actuator/on', { method: 'POST' })
              //   .then(response => response.json())
              //   .then(data => setActuatorState(data.status));
              
              console.warn("⚠️ Funzionalità non implementata - Serve API REST nel backend");
            }}
          />
          <PrimaryButton
            text="Disattiva attuatore"
            disabled={actuatorState === "Spento"}
            onClick={() => {
              // ⚠️ COMMENTATO - Comando MQTT diretto
              // ActuatorCommands.Off();
              
              // TODO: Implementare chiamata API REST
              // Example:
              // fetch('/api/actuator/off', { method: 'POST' })
              //   .then(response => response.json())
              //   .then(data => setActuatorState(data.status));
              
              console.warn("⚠️ Funzionalità non implementata - Serve API REST nel backend");
            }}
          />
          <Label>Stato attuale</Label>
          <div>{actuatorState}</div>
        </div>

        <h2>Storico eventi</h2>
        <Loadable
          isLoading={loading}
          content={
            <div>
              <DataTable
                columns={[
                  {
                    name: "Data",
                    fieldName: "createdAt",
                    dataType: "date/time",
                    size: "small",
                  },
                  {
                    name: "Tipo",
                    fieldName: "type",
                    dataType: "string",
                    size: "medium",
                  },
                  {
                    name: "Descrizione",
                    fieldName: "content",
                    dataType: "string",
                    size: "medium",
                  },
                ]}
                rowData={logs}
              />
            </div>
          }
        />
      </div>
    </div>
  );
};

export default DomoticaPage;
